import React from 'react';

export interface IWithAnalyticsReturn {
    page: (name?: any, category?: any, properties?: any, options?: any) => void;
    track: (name: any, properties?: any, options?: any) => void;
    Identify: (userId: any, traits?: any, options?: any, callback?: any) => void;
    Alias: (userId: any, properties?: any, options?: any) => void;
    logRevenue: (price?: any, revenue?: any, discount?: any, coupon?: any, products?: any, orderId?: any, affiliation?: any) => void;
    logCancel: (price?: any, revenue?: any, discount?: any, coupon?: any, products?: any, orderId?: any, affiliation?: any, reason?: any) => void;
}

function withAnalytics<T>(Component: React.ComponentType<T>) {
  return (props: any) => {
    const page = (name?: any, category?: any, properties?: any, options?: any) => {
      let props = {
        ...properties,
        isMobileApp: !!window && !!(window as any).ReactNativeWebView
      };
      if ((window as any).analytics) {
        (window as any).analytics.page(category, name, props, {
          ...options,
          context: { ip: '0.0.0.0' },
        });
      }
    };

    const track = (name: any, properties?: any, options?: any) => {
      if ((window as any).analytics) {
        let props = {
          ...properties,
          isMobileApp: !!window && !!(window as any).ReactNativeWebView
        };
        (window as any).analytics.track(name, props, {
          ...options,
          context: { ip: '0.0.0.0' },
        });
      }
    };

    const Identify = (userId: any, traits?: any, options?: any, callback?: any) => {
      if ((window as any).analytics) {
        (window as any).analytics.identify(
          userId,
          traits,
          { ...options, isMobileApp: !!window && !!(window as any).ReactNativeWebView, context: { ip: '0.0.0.0' } },
          callback
        );
      }
    };

    const Alias = (userId: any, properties?: any, options?: any) => {
      if ((window as any).analytics) {
        let props = {
          ...properties,
          isMobileApp: !!window && !!(window as any).ReactNativeWebView
        };
        (window as any).analytics.alias(userId, props, {
          ...options,
          context: { ip: '0.0.0.0' },
        });
      }
    };

    const logRevenue = (price?: any, revenue?: any, discount?: any, coupon?: any, products?: any, orderId?: any, affiliation?: any) => {
      track('Order Completed', {
        orderId,
        affiliation,
        total: price,
        revenue: revenue,
        shipping: 1,
        discount: discount,
        coupon: coupon,
        currency: 'USD',
        products,
      });
    };

    const logCancel = (price?: any, revenue?: any, discount?: any, coupon?: any, products?: any, orderId?: any, affiliation?: any, reason?: any) => {
      track('Order Cancelled', {
        orderId,
        affiliation,
        total: price,
        revenue: revenue,
        shipping: 1,
        discount: discount,
        coupon: coupon,
        currency: 'USD',
        products,
        reason
      });
    };

    const rest = {
      ...props,
      analytics: {
        page,
        track,
        Identify,
        Alias,
        logRevenue,
        logCancel
      },
    };

    return <Component {...rest as T & IWithAnalyticsReturn} />
  }
}

export default withAnalytics;
